import type { BattleInitial } from '@pokebot/shared/battle';

/** Dev-only 1v1 until overworld wires encounters. */
export const DEV_BATTLE_INITIAL: BattleInitial = {
  seed: 42,
  player: {
    speciesId: 'bulbasaur',
    level: 10,
    moveIds: ['tackle', 'vine_whip'],
  },
  opponent: {
    speciesId: 'rattata',
    level: 8,
    moveIds: ['tackle', 'quick_attack'],
  },
};
